import PropTypes from 'prop-types';
import ProtocolCard from 'features/stepByStepProtocol/components/ProtocolCard/ProtocolCard';

// Shown instead of the protocol when it cannot be read, is invalid, or the panel itself fails (R1-13, R10).
// `note` says what helps, when something does (a reload after the panel chunk failed to load).
function ProtocolUnavailableCard({ note = '' }) {
    return <ProtocolCard icon="info" title="Unavailable" subtitle="Protocol instructions are currently unavailable." note={note} />;
}

ProtocolUnavailableCard.propTypes = {
    note: PropTypes.string,
};

export default ProtocolUnavailableCard;
